var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-change-dropout-not-audit-final-reject"},[_c('el-form-item',{attrs:{"label":"驳回理由"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"200"},model:{value:(_vm.form.auditRemark),callback:function ($$v) {_vm.$set(_vm.form, "auditRemark", $$v)},expression:"form.auditRemark"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }